import { AuditEntry } from '../../components/auditlog/auditlogComponent';
import { timeReportState } from '../../objects/Attendance';
import './timeReportDialog.less';

/**
 * @typedef { import('../../server/ApiServer').ApiServer } ApiServer
 * @typedef { import('../../objects/Attendance').Attendance } Attendance
 */

angular.module("tromanWeb").controller('TimeReportDialogController', ['ObjectCache', 'tromanServer', 'dialogService', '$uibModalInstance', 'attendance', 'canRecall',
    /**
     * @param {any} ObjectCache
     * @param {ApiServer} tromanServer
     * @param {any} dialogService
     * @param {any} $uibModalInstance
     * @param {Attendance} attendance
     */
    function (ObjectCache, tromanServer, dialogService, $uibModalInstance, attendance, canRecall) {
        this.attendance = attendance;
        this.timeReport = attendance.TimeReport;
        this.isRejected = false;
        this.canRecall = false;
        this.canReactivate = false;
        this.showReportedTimes = false;

        ObjectCache.getAllUsers().then(users => {
            this.audit = AuditEntry.generateAudit(this.timeReport.AuditEntries, users);
        });

        switch (this.timeReport.State) {
            case timeReportState.accepted:
                this.status = 'Godkänd';
                this.showReportedTimes = true;
                break;
            case timeReportState.rejected:
                this.status = 'Avslagen, väntar på svar';
                this.canRecall = canRecall;
                this.isRejected = true;
                break;
            case timeReportState.recalled:
                this.status = 'Avslagen, begäran återkallad';
                this.canReactivate = true;
                break;
            case timeReportState.reported:
                this.status = 'Svar mottaget, ej behandlat';
                this.showReportedTimes = true;
                break;
            case timeReportState.requested:
                this.status = 'Väntar på svar';
                this.canRecall = canRecall;
                break;
        }

        this.recallTimereport = function () {
            dialogService.confirm(['Återkalla begäran om tidrapport']).then(() => {
                tromanServer.Payroll.recallTimereport(attendance.Meeting.Id, {
                    AttendanceId: attendance.Id,
                    RowVersion: attendance.RowVersion,
                }).then(newAttendance => {
                    $uibModalInstance.close({
                        action: 'recalled',
                        newAttendance: newAttendance,
                    });
                }).catch(err => {
                    this.error = err;
                });
            });
        };

        this.reactivateTimereport = function () {
            dialogService.confirm(['Aktivera begäran om tidrapport']).then(() => {
                tromanServer.Payroll.reactivateTimereport(attendance.Meeting.Id, {
                    AttendanceId: attendance.Id,
                    RowVersion: attendance.RowVersion,
                }).then(newAttendance => {
                    $uibModalInstance.close({
                        action: 'reactivated',
                        newAttendance: newAttendance,
                    });
                }).catch(err => {
                    this.error = err;
                });
            });
        };

        this.close = function () {
            $uibModalInstance.close(null);
        };
    }
]);
